import { Base } from '@studiometa/js-toolkit';
import ToggledSectionChildItem from './ToggledSectionChildItem.js';

/**
 * ToggledSectionChild
 */
export default class ToggledSectionChild extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'ToggledSectionChild',
    components: {
      ToggledSectionChildItem,
    },
  };

  /**
   * showItems
   */
  showItems() {
    this.$el.classList.remove('invisible');
    this.$children.ToggledSectionChildItem.forEach((item) => {
      item.show();
    });
  }

  /**
   * showItems
   */
  hideItems() {
    this.$el.classList.add('invisible');
    this.$children.ToggledSectionChildItem.forEach((item) => {
      item.hide();
    });
  }
}
